import { Row, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { IconInformationSmall } from "@amzn/stencil-react-icons";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

export const VendorCostDisclaimer: FC = () => {
  return (
    <Row gridGap={"S100"} style={{ marginTop: "14px", marginBottom: "14px" }} alignItems="start">
      <View>
        <IconInformationSmall />
      </View>

      <Text lineHeight={1.3}>{`${getString("ordering.vendorCostEstimateDisclaimer")} ${getString(
        "ordering.costDisclaimerText"
      )}`}</Text>
    </Row>
  );
};
